import { createElement, memo } from 'rax';
import classNames from 'classnames';
import View from '../../view';
import Icon from '../../icon';
import Progress from '../../progress';
const Card = memo((props) => {
    const { file, onClick, onReUpload, onRemove, hasRemove = true, progressProps = {}, style, reUpload } = props;
    const clsPrefix = props.prefix || 'mt-upload';
    return (<View key={file.uid} className={classNames(`${clsPrefix}-item`, `${clsPrefix}-item--card`, `${clsPrefix}-item--${file.state}`)} style={style}>
      {file.state !== 'error' &&
            (file.imgURL ? (<View className={`${clsPrefix}-item-preview`} onClick={(e) => onClick && onClick(file, e)} style={{
                    backgroundImage: `url(${file.imgURL})`,
                }}/>) : (<View className={`${clsPrefix}-item-waiting`}>
            <Icon className={`${clsPrefix}-item-icon`} name="picture"/>
          </View>))}
      {file.state === 'uploading' && (<Progress className={`${clsPrefix}-item-progress`} percent={file.percent || 0} {...progressProps}/>)}
      {file.state === 'error' && (<View className={`${clsPrefix}-item-error`} onClick={() => onReUpload && onReUpload(file)}>
          <Icon className={classNames(`${clsPrefix}-item-icon`, `${clsPrefix}-item-icon--small`, `${clsPrefix}-item-icon--error`)} name="upload"/>
          {reUpload}
        </View>)}
      {(file.state === 'done' || file.state === 'error') && hasRemove && (<View className={`${clsPrefix}-item-remove`} onClick={() => onRemove && onRemove(file)}>
          <Icon className={`${clsPrefix}-item-remove-icon`} name="minus"/>
        </View>)}
    </View>);
});
export default Card;
